import { render, staticRenderFns } from "./IconEnvelope.vue?vue&type=template&id=efc9dea4"
import script from "./IconEnvelope.vue?vue&type=script&lang=js"
export * from "./IconEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports